export default __webpack_public_path__ + "static/media/detail_mobile_15_2.c954b62b.jpg";